import React from 'react';
import { makeStyles } from 'react-scale/components/design-system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'design-system';

interface AttributePrelabelWrapperProps {
  children: React.ReactNode;
  markPrelabel?: () => void;
}

export const AttributePrelabelWrapper: React.FC<AttributePrelabelWrapperProps> = ({
  children,
  markPrelabel,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.prelabelSelect}>
      <Tooltip
        title={
          'This attribute was predicted by a model. Click this check to accept the prediction or modify the prediction to the correct attribute value'
        }
        placement={'top'}
      >
        <div className={classes.markPrelabelAsDone}>
          <FontAwesomeIcon icon="check" color={'rgba(0, 0, 0)'} onClick={markPrelabel} />
        </div>
      </Tooltip>
      <div className={classes.children}>{children}</div>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  prelabelSelect: {
    display: 'flex',
    flexDirection: 'row',
  },
  markPrelabelAsDone: {
    marginRight: '10px',
    paddingTop: '10px',
    opacity: 0.4,
    '&:hover': {
      opacity: 0.7,
    },
    '&:active': {
      opacity: 1,
    },
    width: '15px',
  },
  children: {
    width: '88%',
  },
}));
